import { useProjectedChart } from "@hooks";
import { constants } from "@layout";

export const BarChart = () => {
  const { projected, invested, x, y, barChartWidth, barChartHeight, investedColor, returnedColor } =
    useProjectedChart();

  const barWidth = (() => {
    const numOfNodes = projected.length;

    if (numOfNodes < 4) return 50;
    if (numOfNodes < 6) return 40;
    if (numOfNodes < 8) return 30;
    if (numOfNodes < 10) return 25;
    if (numOfNodes < 12) return 20;
    if (numOfNodes < 15) return 15;
    if (numOfNodes < 20) return 10;
    if (numOfNodes < 25) return 7;
    if (numOfNodes < 30) return 5;
    if (numOfNodes < 35) return 3.5;
    if (numOfNodes < 40) return 2.5;
    if (numOfNodes < 55) return 2;
    if (numOfNodes < 65) return 1.5;

    return 1;
  })();

  return (
    <svg width={barChartWidth} height={barChartHeight}>
      {projected.map((item, index) => (
        <g key={index}>
          <rect
            x={x(item.age.toString())! - barWidth / 2}
            y={barChartHeight - y(item.amount)}
            rx={constants.chart.projection.barRadius}
            width={barWidth}
            height={y(item.amount)}
            fill={returnedColor}
          />
        </g>
      ))}

      {invested.map((item, index) => (
        <g key={index}>
          <rect
            x={x(item.age.toString())! - barWidth / 2}
            y={barChartHeight - y(item.amount)}
            rx={constants.chart.projection.barRadius}
            width={barWidth}
            height={y(item.amount)}
            fill={investedColor}
          />
        </g>
      ))}
    </svg>
  );
};
